import { APP_CONFIG } from "../constants/constants";
import { localStorageKeys, useLocalStorage } from "./localStorageItems";

const useAuth = () => {
  const { getLocalStorageItem } = useLocalStorage();
  const accessToken = getLocalStorageItem(localStorageKeys.accessToken);

  const isUserLoggedIn = () => {
    // if (APP_CONFIG.DEBUG.ALL) console.log('access Token', accessToken);
    return accessToken !== null && accessToken !== undefined;
  };

  return { isUserLoggedIn };
};

export default useAuth;
